import { render, staticRenderFns } from "./bottom-footer.vue?vue&type=template&id=4d0ceedd&scoped=true&"
import script from "./bottom-footer.vue?vue&type=script&lang=js&"
export * from "./bottom-footer.vue?vue&type=script&lang=js&"
import style0 from "./bottom-footer.vue?vue&type=style&index=0&id=4d0ceedd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ceedd",
  null
  
)

export default component.exports